function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { combine as e, createStore as r, createEvent as i, sample as n, merge as o, guard as s, withFactory as t } from "effector";
import { useStore as a } from "effector-react";
var d = {
  store: function store(_ref, o) {
    var e = _ref.init,
        i = _ref.domain,
        n = _ref.existing;
    return n || (i ? i.store(e, {
      and: o,
      sid: "-efg263"
    }) : r(e, {
      and: o,
      sid: "-dyefrw"
    }));
  },
  event: function event(_ref2) {
    var e = _ref2.domain,
        r = _ref2.existing;
    return r || (e ? e.event({
      sid: "-y6riru"
    }) : i({
      sid: "-y6rhv4"
    }));
  }
};

function u(r, i, n, o) {
  var s, t, a, u, l, m, c, v, f, h, g;
  var E = "function" == typeof i.init ? i.init() : i.init,
      x = d.store({
    domain: n,
    existing: null === (s = i.units) || void 0 === s ? void 0 : s.$value,
    init: E
  }, {
    and: o,
    name: "$value",
    sid: "yg99i6"
  }),
      V = d.store({
    domain: n,
    existing: null === (t = i.units) || void 0 === t ? void 0 : t.$errors,
    init: []
  }, {
    and: o,
    name: "$errors",
    sid: "-y2xdpq"
  }),
      p = V.map(function (e) {
    return e[0] ? e[0] : null;
  }),
      $ = x.map(function (e) {
    return e !== E;
  }),
      y = d.store({
    domain: n,
    existing: null === (a = i.units) || void 0 === a ? void 0 : a.$isTouched,
    init: !1
  }, {
    and: o,
    name: "$touched",
    sid: "sulkei"
  }),
      b = d.event({
    domain: n,
    existing: null === (u = i.units) || void 0 === u ? void 0 : u.onChange
  }, {
    name: "onChange",
    sid: "-bvxucw"
  }),
      k = d.event({
    domain: n,
    existing: null === (l = i.units) || void 0 === l ? void 0 : l.onBlur
  }, {
    name: "onBlur",
    sid: "mo0ar0"
  }),
      T = d.event({
    domain: n,
    existing: null === (m = i.units) || void 0 === m ? void 0 : m.changed
  }, {
    name: "changed",
    sid: "bcod8v"
  }),
      w = d.event({
    domain: n,
    existing: null === (c = i.units) || void 0 === c ? void 0 : c.addError
  }, {
    name: "addError",
    sid: "3cou8n"
  }),
      F = d.event({
    domain: n,
    existing: null === (v = i.units) || void 0 === v ? void 0 : v.validate
  }, {
    name: "validate",
    sid: "-s3sqr5"
  }),
      j = d.event({
    domain: n,
    existing: null === (f = i.units) || void 0 === f ? void 0 : f.resetErrors
  }, {
    name: "resetErrors",
    sid: "z8u2jo"
  }),
      D = d.event({
    domain: n,
    existing: null === (h = i.units) || void 0 === h ? void 0 : h.resetValue
  }, {
    name: "resetValue",
    sid: "-x0qhaf"
  }),
      B = d.event({
    domain: n,
    existing: null === (g = i.units) || void 0 === g ? void 0 : g.reset
  }, {
    name: "reset",
    sid: "ocz45p"
  }),
      O = p.map(function (e) {
    return null === e;
  });
  return {
    changed: T,
    name: r,
    $value: x,
    $errors: V,
    $firstError: p,
    $isValid: O,
    $isDirty: $,
    $isTouched: y,
    $touched: y,
    $field: e({
      and: [{
        value: x,
        errors: V,
        firstError: p,
        isValid: O,
        isDirty: $,
        isTouched: y
      }],
      or: {
        name: "$field",
        sid: "-vj0i5c"
      }
    }),
    onChange: b,
    onBlur: k,
    addError: w,
    validate: F,
    set: b,
    reset: B,
    resetErrors: j,
    resetValue: D,
    filter: i.filter
  };
}

function l(_ref3, f) {
  var i = _ref3.$form,
      s = _ref3.validateFormEvent,
      t = _ref3.submitEvent,
      a = _ref3.resetFormEvent,
      d = _ref3.resetValues,
      u = _ref3.field,
      l = _ref3.rules,
      m = _ref3.resetErrors,
      c = _ref3.formValidationEvents,
      v = _ref3.fieldValidationEvents;
  var h = u.$value,
      g = u.$errors,
      E = u.onBlur,
      x = u.changed,
      V = u.addError,
      p = u.validate,
      $ = u.resetErrors,
      y = u.resetValue,
      b = u.reset,
      k = "function" == typeof l ? r([], {
    and: f,
    name: "rulesSources",
    sid: "-9d7qjb"
  }) : e({
    and: [l.map(function (_ref4) {
      var e = _ref4.source;
      return e || r(null, {
        and: f,
        name: "and",
        sid: "5j6y42"
      });
    })],
    or: {
      name: "rulesSources",
      sid: "-8w6454"
    }
  }),
      T = (w = l, function (e, r, i) {
    var n = [],
        o = "function" == typeof w ? w(e, r) : w;

    for (var _s = 0; _s < o.length; _s++) {
      var _t = o[_s],
          _a = i ? i[_s] : null,
          _d = _t.validator(e, r, _a);

      "boolean" != typeof _d || _d || n.push({
        rule: _t.name,
        errorText: _t.errorText,
        value: e
      }), "object" != _typeof(_d) || _d.isValid || n.push({
        rule: _t.name,
        errorText: _d.errorText,
        value: e
      });
    }

    return n;
  });
  var w;
  var F = [].concat(_toConsumableArray(c), _toConsumableArray(v)),
      j = [];

  if (F.includes("submit")) {
    var _r = n({
      and: [{
        source: e({
          and: [{
            fieldValue: h,
            form: i,
            rulesSources: k
          }],
          or: {
            name: "source",
            sid: "-k8128n"
          }
        }),
        clock: t
      }],
      or: {
        name: "validationTrigger",
        sid: "-6xbmu5"
      }
    });

    j.push(_r);
  }

  F.includes("blur") && j.push(n({
    and: [{
      source: e({
        and: [{
          fieldValue: h,
          form: i,
          rulesSources: k
        }],
        or: {
          name: "source",
          sid: "pucwwk"
        }
      }),
      clock: E
    }],
    or: {
      sid: "-m25isl"
    }
  })), F.includes("change") && j.push(n({
    and: [{
      source: e({
        and: [{
          fieldValue: h,
          form: i,
          rulesSources: k
        }],
        or: {
          name: "source",
          sid: "-uicuuj"
        }
      }),
      clock: o([x, y, d], {
        name: "clock",
        sid: "wzy69w"
      })
    }],
    or: {
      sid: "-7dr8kk"
    }
  })), j.push(n({
    and: [{
      source: e({
        and: [{
          fieldValue: h,
          form: i,
          rulesSources: k
        }],
        or: {
          name: "source",
          sid: "-gb07m8"
        }
      }),
      clock: p
    }],
    or: {
      sid: "6tlenr"
    }
  })), j.push(n({
    and: [{
      source: e({
        and: [{
          fieldValue: h,
          form: i,
          rulesSources: k
        }],
        or: {
          name: "source",
          sid: "-2kp66l"
        }
      }),
      clock: s
    }],
    or: {
      sid: "kjwg3e"
    }
  }));
  var D = n({
    and: [{
      source: h,
      clock: V,
      fn: function fn(e, _ref5) {
        var r = _ref5.rule,
            i = _ref5.errorText;
        return {
          rule: r,
          value: e,
          errorText: i
        };
      }
    }],
    or: {
      name: "addErrorWithValue",
      sid: "-vn5aoo"
    }
  });
  g.on(j, function (e, _ref6) {
    var r = _ref6.form,
        i = _ref6.fieldValue,
        n = _ref6.rulesSources;
    return T(i, r, n);
  }).on(D, function (e, r) {
    return [r].concat(_toConsumableArray(e));
  }).reset($, a, b, m), F.includes("change") || g.reset(x);
}

function m(_ref7, u, l, m, c) {
  var e = _ref7.$value,
      r = _ref7.$touched,
      i = _ref7.onChange,
      n = _ref7.changed,
      o = _ref7.name,
      t = _ref7.reset,
      a = _ref7.resetValue,
      d = _ref7.filter;
  r.on(n, function () {
    return !0;
  }).reset(t, l, m), s({
    and: [{
      source: i,
      filter: d || function () {
        return !0;
      },
      target: n
    }],
    or: {
      sid: "-ylchks"
    }
  }), e.on(n, function (e, r) {
    return r;
  }).on(u, function (e, r) {
    return r.hasOwnProperty(o) ? r[o] : e;
  }).reset(t, a, c, l);
}

function c(r) {
  var i = r.filter,
      o = r.domain,
      a = r.fields,
      c = r.validateOn,
      v = r.units,
      f = {},
      h = [],
      g = [];

  var _loop = function _loop(_e) {
    if (!a.hasOwnProperty(_e)) return "continue";
    var r = a[_e],
        i = t({
      sid: "tpjlm9",
      fn: function fn() {
        return u(_e, r, o, {
          sid: _e
        });
      },
      name: "field",
      method: "createField"
    });
    f[_e] = i, h.push(i.$isDirty), g.push(i.$touched);
  };

  for (var _e in a) {
    var _ret = _loop(_e);

    if (_ret === "continue") continue;
  }

  var E = function (r) {
    var i = {};

    for (var _e2 in r) {
      r.hasOwnProperty(_e2) && (i[_e2] = r[_e2].$value);
    }

    return e({
      and: [i],
      or: {
        sid: "3r0gj3"
      }
    });
  }(f),
      x = function (r) {
    var i = [];

    for (var _e3 in r) {
      if (!r.hasOwnProperty(_e3)) continue;
      var _n = r[_e3].$firstError;
      i.push(_n);
    }

    return e({
      and: [i],
      or: {
        name: "$firstErrors",
        sid: "-1vosn1"
      }
    }).map(function (e) {
      return e.every(function (e) {
        return null === e;
      });
    });
  }(f),
      V = i ? e({
    and: [x, i, function (e, r) {
      return e && r;
    }],
    or: {
      name: "$isFormValid",
      sid: "-mzafst"
    }
  }) : x,
      p = e({
    and: [h],
    or: {
      name: "$isDirty",
      sid: "-dlthzi"
    }
  }).map(function (e) {
    return e.some(Boolean);
  }),
      $ = e({
    and: [g],
    or: {
      name: "$touched",
      sid: "-tje8ud"
    }
  }).map(function (e) {
    return e.some(Boolean);
  }),
      y = e({
    and: [{
      isValid: x,
      isDirty: p,
      touched: $
    }],
    or: {
      name: "$meta",
      sid: "2bfvkz"
    }
  }),
      b = d.event({
    domain: o,
    existing: null == v ? void 0 : v.validate
  }, {
    name: "validate",
    sid: "yvbjh5"
  }),
      k = d.event({
    domain: o,
    existing: null == v ? void 0 : v.submit
  }, {
    name: "submitForm",
    sid: "4v9jaw"
  }),
      T = d.event({
    domain: o,
    existing: null == v ? void 0 : v.formValidated
  }, {
    name: "formValidated",
    sid: "q51mub"
  }),
      w = d.event({
    domain: o,
    existing: null == v ? void 0 : v.setForm
  }, {
    name: "setForm",
    sid: "-myvat3"
  }),
      F = d.event({
    domain: o,
    existing: null == v ? void 0 : v.reset
  }, {
    name: "resetForm",
    sid: "-khripr"
  }),
      j = d.event({
    domain: o,
    existing: null == v ? void 0 : v.resetValues
  }, {
    name: "resetValues",
    sid: "ygut7h"
  }),
      D = d.event({
    domain: o,
    existing: null == v ? void 0 : v.resetErrors
  }, {
    name: "resetErrors",
    sid: "-wgu0qt"
  }),
      B = d.event({
    domain: o,
    existing: null == v ? void 0 : v.resetTouched
  }, {
    name: "resetTouched",
    sid: "x0xold"
  }),
      O = n({
    and: [{
      source: E,
      clock: k
    }],
    or: {
      name: "submitWithFormData",
      sid: "-6a1prv"
    }
  }),
      C = n({
    and: [{
      source: E,
      clock: b
    }],
    or: {
      name: "validateWithFormData",
      sid: "-wefxh0"
    }
  });

  var _loop2 = function _loop2(_e4) {
    if (!f.hasOwnProperty(_e4)) return "continue";
    var r = a[_e4],
        i = f[_e4];
    t({
      sid: "oj3q0b",
      fn: function fn() {
        return m(i, w, F, B, j);
      },
      name: "none",
      method: "bindChangeEvent"
    }), r.rules && t({
      sid: "okr3se",
      fn: function fn() {
        return l({
          $form: E,
          rules: r.rules,
          submitEvent: k,
          resetFormEvent: F,
          resetValues: j,
          resetErrors: D,
          validateFormEvent: b,
          field: i,
          formValidationEvents: c || ["submit"],
          fieldValidationEvents: r.validateOn ? r.validateOn : []
        }, {
          sid: _e4
        });
      },
      name: "none",
      method: "bindValidation"
    });
  };

  for (var _e4 in f) {
    var _ret2 = _loop2(_e4);

    if (_ret2 === "continue") continue;
  }

  return s({
    and: [{
      source: O,
      filter: V,
      target: T
    }],
    or: {
      sid: "2vvi0m"
    }
  }), s({
    and: [{
      source: C,
      filter: V,
      target: T
    }],
    or: {
      sid: "2z69ks"
    }
  }), {
    fields: f,
    $values: E,
    $eachValid: x,
    $isValid: x,
    $isDirty: p,
    $touched: $,
    $meta: y,
    submit: k,
    validate: b,
    resetTouched: B,
    reset: F,
    resetValues: j,
    resetErrors: D,
    setForm: w,
    set: w,
    formValidated: T
  };
}

function v(e) {
  var _a2 = a(e.$field),
      r = _a2.value,
      i = _a2.errors,
      n = _a2.firstError,
      o = _a2.isValid,
      s = _a2.isDirty,
      t = _a2.isTouched;

  return {
    name: e.name,
    value: r,
    errors: i,
    firstError: n,
    isValid: o,
    isDirty: s,
    touched: t,
    isTouched: t,
    onChange: e.onChange,
    onBlur: e.onBlur,
    addError: e.addError,
    validate: e.validate,
    reset: e.reset,
    set: e.onChange,
    resetErrors: e.resetErrors,
    hasError: function hasError() {
      return null !== n;
    },
    errorText: function errorText(e) {
      return n ? e && e[n.rule] ? e[n.rule] : n.errorText || "" : "";
    }
  };
}

function f(e) {
  var r = {},
      i = {};

  for (var _n2 in e.fields) {
    if (!e.fields.hasOwnProperty(_n2)) continue;

    var _o = v(e.fields[_n2]);

    r[_n2] = _o, i[_n2] = _o.value;
  }

  var _a3 = a(e.$meta),
      n = _a3.isValid,
      o = _a3.isDirty,
      s = _a3.touched;

  return {
    fields: r,
    values: i,
    hasError: function hasError(e) {
      return e ? !!r[e] && Boolean(r[e].firstError) : !n;
    },
    eachValid: n,
    isValid: n,
    isDirty: o,
    isTouched: s,
    touched: s,
    errors: function errors(e) {
      return r[e] ? r[e].errors : [];
    },
    error: function error(e) {
      return r[e] ? r[e].firstError : null;
    },
    errorText: function errorText(e, i) {
      var n = r[e];
      return n && n.firstError ? i && i[n.firstError.rule] ? i[n.firstError.rule] : n.firstError.errorText || "" : "";
    },
    reset: e.reset,
    submit: e.submit,
    setForm: e.setForm,
    set: e.setForm,
    formValidated: e.formValidated
  };
}

export { c as createForm, v as useField, f as useForm };